import { useEffect, useRef } from 'react';
import { VerticalLayout } from '../../common/common-layout';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import { useHideMenu } from '../../hooks/useHideMenu';
import { useScrollMenuHandler } from '../../hooks/useScrollMenuHandler';
import { useSectionInView } from '../../hooks/useSectionInView';
import menuStore from '../../store/MenuStore';
import { AnimatedWrapper } from '../base/AnimatedWrapper';
import FooterSection from '../base/FooterSection';
import FooterSectionMobile from '../base/FooterSectionMobile';
import SemiconductorFieldSection1 from './SemiconductorFieldSection1';
import SemiconductorFieldSection2 from './SemiconductorFieldSection2';

const BusinessMainPage = () => {
  const { isMobile } = useDeviceType();
  useScrollMenuHandler();
  useHideMenu();

  const section1Ref = useRef<HTMLDivElement>(null);
  const inView1 = useSectionInView(section1Ref);

  useEffect(() => {
    menuStore.setBackgroundColor('transparent');
  }, []);

  useEffect(() => {
    menuStore.setDarkMode(inView1);
  }, [inView1]);

  return (
    <VerticalLayout>
      <div ref={section1Ref} style={{ width: '100%', overflow: 'hidden', 
        ...(isMobile ? {} : { aspectRatio: '1913 / 1048' }),
       }}>
        <SemiconductorFieldSection1 />
      </div>
      <AnimatedWrapper style={{ width: '100%', overflowX: 'hidden' }}>
        <SemiconductorFieldSection2 />
      </AnimatedWrapper>
      <div style={{ width: '100%', overflowX: 'hidden' }}>
        {isMobile ? <FooterSectionMobile /> : <FooterSection />}
      </div>
    </VerticalLayout>
  );
};

export default BusinessMainPage;
